import { Accordion } from "@mui/material";
import { useState, useEffect } from "react";

import CustomNotesAccordionDetails from "../Accordion/CustomNotesAccordionDetails";
import CustomNotesAccordionSummary from "../Accordion/CustomNotesAccordionSummary";

export default function NotesListItem({
  data,
  handleEdit,
  handleOnClickPin,
  notePermissionsHook,
}) {
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    setExpanded(true);
  }, [data?.id]);

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  const handleEditWrapper = (note) => {
    handleEdit(note);
    setExpanded(true);
  };

  return (
    <Accordion
      disableGutters
      elevation={0}
      expanded={expanded}
      onChange={handleToggle}
      sx={{
        "&::before": { display: "none" },
      }}
    >
      <CustomNotesAccordionSummary data={data} />
      <CustomNotesAccordionDetails
        data={data}
        handleEdit={handleEditWrapper}
        handleOnClickPin={handleOnClickPin}
        notePermissionsHook={notePermissionsHook}
      />
    </Accordion>
  );
}
